export default __webpack_public_path__ + "static/complian-d0d3c378b793e65da6333f24ef1f075e.png";